export default class ParticipantPayLoadViewModel {
  public static createEmpty(): ParticipantPayLoadViewModel {
    return new ParticipantPayLoadViewModel();
  }

  constructor(
    public Skip:          number   = 0,
    public PageSize:      number   = 0,
    public SearchTerm:    string   = '',
    public NameFilter:    string   = '',
    public CheckInFilter: string   = '',
    public Statuses:      string[] = [],
    public EmailStatuses: string[] = [],
    public TicketTypes:   string[] = [],
    public GroupIds:      number[] = [],
    public HasNote:       boolean  = false,
    public SortBy:                  string   = '',
    public SortDir:                 string   = '',
    public StripeTicketInstanceIds: number[] | null = null,
  ) {}
}
